{
  "open": "Apri la chat",
  "unread_one": "{count} messaggio non letto",
  "unread_many": "{count} di messaggi non letti",
  "unread_other": "{count} messaggi non letti",
  "close": "Chiudi"
}
